module.exports = __webpack_public_path__ + "img/not_found.0a91d696.png";